module.exports = __webpack_public_path__ + "static/media/wrong.8a56ebf3.mp3";